
import axios from "axios";
import config from "./api-config.json";

const { baseURL, baseBlogURL, baseNewsURL } = config;

function transformData(data) {
  return data.map((item) => ({
    ...item.acf,  // Keep the contents of item.acf
    id: item.id,  // Add the id property
  }));;
}

async function fetchData(endpoint, params = {}) {
  try {
    const response = await axios.get(`${baseURL}/${endpoint}`, { params });
    return transformData(response.data);
  } catch (error) {
    console.error(`Error fetching ${endpoint} data:`, error);
    throw error; // Re-throw the error for higher-level handling if needed.
  }
}

async function fetchBlog(params = {}) {
  try {
    const response = await axios.get(`${baseBlogURL}`, { params });
    return transformData(response.data);
  } catch (error) {
    console.error(`Error fetching blogs data:`, error);
    throw error; // Re-throw the error for higher-level handling if needed.
  }
}

async function fetchContent(contentId, type) {
  let baseUrl = type == "news" ? baseNewsURL : baseBlogURL;
  try {
    const response = await axios.get(`${baseUrl}` + '/' + contentId);
    // console.log(`fetching blogs data:`, `${baseUrl}` + '/' + contentId);
    const news = response.data.acf;
    // console.log(`fetching blogs data:`, news);
    return news;
  } catch (error) {
    console.error(`Error fetching blogs data:`, error);
    throw error; // Re-throw the error for higher-level handling if needed.
  }
}



export const fetchWidgetStatus = async () => {
  let baseUrl = "https://core.service.elfsight.com/p/boot/?w=6ba80bfc-f559-462a-947e-4ea821fe824c,db256bef-fca0-4270-a1b4-115a43814980,2ddb98d7-73ad-4d77-8e3f-950b346f8add,3460b1e2-cfc2-408e-a1f9-2ed8fcfee7c1";
  try {
    const response = await axios.get(baseUrl);
    const widgetsList = response.data.data.widgets;

    return widgetsList;
  } catch (error) {
    console.error(`Error fetching blogs data:`, error);
    throw error; // Re-throw the error for higher-level handling if needed.
  }
}

// http://localhost/wpf/wp-json/wp/v2/blogs?slug=06-06-2023
// per_page=0&meta_key=news_date&orderby=meta_value&order=ASC

export const getNews = (id) => fetchContent(id, "news");
export const getNewsTeaser = () => fetchData("news", { per_page: 100, meta_key: "news_date", orderby: "meta_value", order: "DESC" });
export const getReferences = () => fetchData("references", { per_page: 100, orderby: "title", order: "asc" });
export const getBlogTeaser = () => fetchData("blogs", { orderby: "date", order: "desc" });
// export const getBlogTeaser = () => fetchData("blogs_preview", { orderby: "date", order: "desc" });
export const getBlog = (id) => fetchContent(id, "blog");
// export const getBlog = (date) => fetchBlog({ slug: date });
// export const getBlog = (date) => fetchBlog({ slug: date });

export const getTeam = () => fetchData("team_members", { orderby: "date", order: "asc" });
export const getPartners = () => fetchData("partners", { per_page: 100, orderby: "date", order: "asc" });
export const getCareers = () => fetchData("careers", { per_page: 100 });





export const convertDateFormat = (inputDate) => {
  const [day, month, year] = inputDate.split('-').map(Number);
  const fullYear = year < 100 ? 2000 + year : year; // Assuming years like "13" correspond to 2013

  // Using String.padStart() to ensure day and month are two digits
  const formattedDay = String(day).padStart(2, '0');
  const formattedMonth = String(month).padStart(2, '0');

  const formattedDate = `${formattedDay}.${formattedMonth}.${fullYear}`;

  return formattedDate;
}